import { FilterSettings } from 'components/tables/Table.interfaces';
import { MontelAccount } from 'domain/account/interfaces';
import moment from 'moment';

export const columnFilters: FilterSettings<MontelAccount> = {
	treatGroupsAsSingle: false,
	groups: [
		{
			columnId: 'activeStatus',
			filters: [
				{
					text: 'All',
					value: 'all',
					selected: true,
				},
				{
					text: 'Active',
					value: 'active',
					selected: false,
				},
				{
					text: 'Locked',
					value: 'locked',
					selected: false,
				},
				{
					text: 'Reserved',
					value: 'reserved',
					selected: false,
				},
			],
		},
		{
			columnId: 'accountCreated',
			groupCanBeCleared: true,
			filters: [
				{
					text: 'New last 24 hours',
					value: moment().utc().subtract(1, 'days'),
					selected: false,
				},
				{
					text: 'New last 7 days',
					value: moment().utc().subtract(7, 'days'),
					selected: false,
				},
			],
		},
		{
			columnId: 'email',
			groupCanBeCleared: true,
			filters: [
				{
					text: 'Hide unverified',
					value: 'hide-unverified',
					selected: false,
				},
			],
		},
	],
};
